/* eslint-disable */
export const DELIVERIES_ALL = `[DELIVERIES] ALL`;
export const DELIVERIES_ALL_COMPLETE = `[DELIVERIES] ALL COMPLETE`;
export const DELIVERIES_ALL_ERROR = `[DELIVERIES] ALL ERROR`;
export const DELIVERIES_ALL_SUCCESS = `[DELIVERIES] ALL SUCCESS`;

export const DELIVERIES_FIND_BY_ID = `[DELIVERIES] FIND BY ID`;
export const DELIVERIES_FIND_BY_ID_COMPLETE = `[DELIVERIES] FIND BY ID COMPLETE`;
export const DELIVERIES_FIND_BY_ID_ERROR = `[DELIVERIES] FIND BY ID ERROR`;
export const DELIVERIES_FIND_BY_ID_SUCCESS = `[DELIVERIES] FIND BY ID SUCCESS`;

export const DELIVERIES_FIND_BY_DATE = `[DELIVERIES] FIND BY DATE`;
export const DELIVERIES_FIND_BY_DATE_COMPLETE = `[DELIVERIES] FIND BY DATE COMPLETE`;
export const DELIVERIES_FIND_BY_DATE_ERROR = `[DELIVERIES] FIND BY DATE ERROR`;
export const DELIVERIES_FIND_BY_DATE_SUCCESS = `[DELIVERIES] FIND BY DATE SUCCESS`;

export const DELIVERIES_UPDATE_BY_ID = `[DELIVERIES] UPDATE BY ID`;
export const DELIVERIES_UPDATE_BY_ID_COMPLETE = `[DELIVERIES] UPDATE BY ID COMPLETE`;
export const DELIVERIES_UPDATE_BY_ID_ERROR = `[DELIVERIES] UPDATE BY ID ERROR`;
export const DELIVERIES_UPDATE_BY_ID_SUCCESS = `[DELIVERIES] UPDATE BY ID SUCCESS`;

export const DELIVERIES_FILTERS_UPDATE = `[DELIVERIES] FILTERS UPDATE`;
